import React from 'react';

import ProfilePanel from '../../../../modules/integrations/google/components/ProfilePanel/ProfilePanel';

export default function ConnectionTab() {
  return <ProfilePanel />;
}
